module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1CXUXty/images/cover.jpg?1684514921836",
      "alt": "This image is the cover for the book Bound by Guilt"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Bound by Guilt\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Kit Mason works at Eddy’s, a boutique where the clothes are chic, the paycheck’s weak, and Kit has no qualms about snagging rich older men looking to pay for play. When Cory St. James walks in, he checks all Kit’s boxes: he’s middle-aged, the entrepreneur of a pharmaceutical company, and already has a kept boy at home—what’s one more? Kit sets out to seduce Cory and bulldozes through his denials, but when Cory finally gives in, his lover, Sasha, catches them with their pants down.")]), _vm._v(" "), _c('p', [_vm._v("Sasha isn’t the pampered toy Kit expected. In fact, Kit may have misjudged him. And the consequences that ensue when Sasha catches Kit and Cory together leave him alone. Unwilling to be weighed down by guilt, Kit decides to look after Sasha himself, even if Sasha can’t stand the sight of him and there are a few things about Kit's past he doesn't want Sasha to know. But Kit isn't willing to do all the work when it comes to forcing Sasha to rebuild his life. It’s a slow process of growing trust and learning to stand on their own—and together.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Sandra Bard\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0